/**
 * MobileMenu
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { Transition } from 'react-transition-group';
import { useUuid } from 'ui-component-library/hooks';
import { Cell, Grid } from '../Grid';
import Icon from '../Icon';
/** Main description for this component. */
var MobileMenu = function (_a) {
    var navigationButtonLabel = _a.navigationButtonLabel, openMenuItemLabel = _a.openMenuItemLabel, closeMenuItemLabel = _a.closeMenuItemLabel, location = _a.location, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, ariaLabel = _a.ariaLabel, children = _a.children, className = _a.className;
    var getUuid = useUuid()[0];
    var _c = useState(isOpen), expanded = _c[0], setExpanded = _c[1];
    var id = getUuid();
    var menuRef = useRef(null);
    var handleClickOutside = function (e) {
        var _a;
        if (menuRef && menuRef.current && !menuRef.current.contains(e.target)) {
            (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.classList.remove('relative');
            setExpanded(false);
        }
    };
    var handleKeyPress = function (e) {
        if ((e.keyCode || e.which) === 27) {
            setExpanded(false);
        }
    };
    var handleBlur = function (e) {
        setExpanded(!expanded);
    };
    useEffect(function () {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyPress);
        if (menuRef && menuRef.current) {
            menuRef.current.addEventListener('blur', handleBlur);
        }
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyPress);
            if (menuRef && menuRef.current) {
                menuRef.current.removeEventListener('blur', handleBlur);
            }
        };
    });
    var renderChildren = function (children) {
        return React.Children.map(children, function (child, index) {
            if (!child) {
                return null;
            }
            var props = child && child.props ? __assign({}, child.props) : {};
            props.openMenuItemLabel = openMenuItemLabel;
            props.closeMenuItemLabel = closeMenuItemLabel;
            return (React.createElement(React.Fragment, { key: index }, React.cloneElement(child, props || {})));
        });
    };
    useEffect(function () {
        setExpanded(false);
    }, [location]);
    return (React.createElement("div", null,
        React.createElement("button", { type: "button", "aria-controls": "mobile-menu-" + id, "aria-expanded": expanded, "data-cid": "MobileMenu", onClick: function () {
                var _a;
                if (!expanded) {
                    (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.classList.add('relative');
                }
                setExpanded(!expanded);
            } },
            React.createElement("span", { className: "mr-2 pl-1 hidden md:inline-block" }, navigationButtonLabel),
            React.createElement(Icon, { icon: expanded ? 'close' : 'menu', "aria-hidden": true, size: 1.25, className: "text-black" })),
        React.createElement(Transition, { in: expanded, timeout: 400 }, function (state) { return (React.createElement("div", { id: "mobile-menu-" + id, hidden: state === 'exited', className: clsx(className, 'absolute w-full z-50', expanded ? 'page-overlay--white' : 'bg-transparent', state === 'exiting' ? 'animate-fade-out' : 'animate-fade-in') },
            React.createElement(Grid, { padding: false, margin: false },
                React.createElement(Cell, { span: 12, className: "md:flex flex-row-reverse" },
                    React.createElement("nav", { ref: menuRef, "aria-label": ariaLabel, className: clsx('w-full md:w-96 bg-white border-t-2 border-white') },
                        React.createElement("ul", null, renderChildren(children))))))); })));
};
export default MobileMenu;
